import React, { useEffect } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="flex flex-col min-h-screen bg-sovereign-navy" data-id="element-112">
      <Navbar data-id="element-113" />
      <AnimatePresence mode="wait" data-id="element-114">
        <motion.main key={location.pathname} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="flex-grow pt-20" data-id="element-115">
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer data-id="element-116" />
    </div>;
}